import styled from 'styled-components';
import { PaginationFooter } from 'ui/paginationFooter';

export const StyledPaginationFooter = styled(PaginationFooter)`
  border-top: none;
`;
